import AttachFileIcon from '@mui/icons-material/AttachFile';
import CommentIcon from '@mui/icons-material/Comment';
import EditIcon from '@mui/icons-material/Edit';
import { Badge, IconButton } from '@mui/material';
import { FormLayoutBuilder, getFormData, DataTable } from '@pihealth/common-ui-library';
import moment from 'moment';
import { default as React, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import DARDocUpload from 'src/components/StartUp/documentUpload/DARDocUpload';
import Notes from 'src/components/common/Notes';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import AppModal from 'src/components/modal';
import { useGetCodeListDataQuery } from 'src/services/codeList';
import { useAppSelector } from 'src/store';
import { setMessage } from 'src/store/Message';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import forms from '../../../../../resources/forms.json';
import { useCommonDrugAccountability } from '../useCommonDrugAccountability';
import { archLevel } from 'src/data/config';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import { useGetPharmacyListMutation } from 'src/services/workarea';
import { useSiteContactInfo } from 'src/components/StartUp/steps/useSitecontactinfo';

const Transfer: React.FunctionComponent<any> = ({
  kitData,
  transferPopupEvent,
  setTransferPopupEvent,
  setPendingTransfers
}: any) => {
  const {
    updateDARDoc,
    createDARNotes,
    getDARNotes,
    getDrugEventRecords,
    getDrugEventRecordsLoading,
    createDrugEventRecords,
    updateDrugEventRecords,
    createDrugEventRecordsSuccess
  } = useCommonDrugAccountability();
  const formGroup = forms.DARTransferAddKit;
  const [codes, setCodes] = useState<any>({});
  const { formFields, defaultValues = {}, rules } = getFormData(formGroup.groups, codes);
  const { groups } = formFields;
  const formRef: any = useRef(null);
  const { user, email } = useUser();
  const [onEdit, setOnEdit] = useState(false);
  const [pageSize, setPageSize] = React.useState(10);
  const currentAppName = archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_TSDA_SLUG;
  const [rowsCount, setRowsCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [filterObject, setFilterObject] = useState<any>();
  const dispatch = useDispatch();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const [updateEditData, setUpdateEditData] = useState<any>({});
  const [rows, setRows] = useState<any>({});
  const [id, setID] = useState('');
  const [progress, setProgress] = useState(false);
  const [commentDilogOpen, setCommentDilogOpen] = useState(false);
  const [uploadDilogOpen, setUploadDilogOpen] = useState<boolean>(false);
  const [uploadedFiles, setUploadedFiles] = useState<any>([]);
  const [progressDocUpload, setProgressDocUpload] = useState<boolean>(false);
  const [notesData, setNotesData] = useState([]);
  const [notetext, setNoteText] = useState('');
  const [pharmacyList, setPharmacyList] = useState([]);
  const [craEmails, setCraEmails] = useState([]);
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const { duFileUploadErrorMsg, duDocumentUploadSuccessMsg } = useFieldTranslation();
  const documentMetaData = {
    name: 'IP Transfer Documentation',
    number: '10.03.08'
  };
  const { checkPermission } = usePermissionWrapper();
  const { data: unitList } = useGetCodeListDataQuery('IPKUNIT');
  const { data: statusData } = useGetCodeListDataQuery('DARRSA');

  useEffect(() => {
    if (unitList) {
      const data: any = unitList;
      const tempArr = data.map((ele: any) => {
        return {
          displayName: ele.code_list_value,
          key: ele.code_list_value
        };
      });
      if (!codes?.IPKUNIT?.length) {
        setCodes({ ...codes, IPKUNIT: tempArr });
      }
    }
  }, [unitList]);
  useEffect(() => {
    getAllDrugEventsData(0, 10);
  }, [selectedSite]);

  useEffect(() => {
    if (!getDrugEventRecordsLoading && (pageSize === 10 || pageSize === 20 || pageSize === 30)) {
      if (pageNumber * pageSize > rowsCount - 1) {
        setPageNumber(0);
        getAllDrugEventsData(0, pageSize);
      } else {
        getAllDrugEventsData(pageNumber * pageSize, pageSize);
      }
    }
  }, [pageNumber, pageSize]);

  useEffect(() => {
    if (filterObject) {
      getAllDrugEventsData(0, pageSize);
    }
  }, [filterObject]);
  const handleEdit = (row_data: any) => {
    setID('');
    setID(row_data.id);
    setUpdateEditData({
      ...row_data,
      da_log_kit_send_to: row_data?.da_log_kit_send_to ? row_data?.da_log_kit_send_to.split(',') : null,
      updated_by: user
    });
    setOnEdit(true);
    setTransferPopupEvent(true);
  };
  const handleSendNote = async (_: any) => {
    if (notetext !== '') {
      sendNotesData(id);
      setNoteText('');
    }
  };
  const sendNotesData = async (id: string) => {
    try {
      await createDARNotes({
        event_id: id,
        data: {
          da_log_kit_notes: notetext,
          created_by: user
        },
        country: selectedCountry,
        application: process.env.REACT_APP_NAME,
        site_id: selectedSite
      });
    } catch (error: any) {
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
    getNotesData(id);
  };
  const getNotesData = async (id: any) => {
    try {
      const res: any = await getDARNotes({ event_id: id });
      const result = res?.data;
      setNotesData(result);
    } catch (error: any) {
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
      setNotesData([]);
    }
  };
  const handleComment = (row: any) => {
    setNotesData([]);
    setID('');
    setCommentDilogOpen(true);
    getNotesData(row.id);
    setID(row.id);
  };
  const formatDate = (params: any) => {
    return moment(params.row.da_log_kit_date_time).format(`${userPreferedDateFormat.toUpperCase()} h:mm A`);
  };
  const handleFileUploadOpen = (row: any) => {
    setID(row.id);
    setUploadedFiles([...row.documents_data]);
    setUploadDilogOpen(true);
  };
  const updateDocs = async (updatedDocIds: string[], isDocDelete = false) => {
    setProgressDocUpload(true);
    try {
      await updateDARDoc({
        event_id: id,
        data: {
          uploaded_file_ids: updatedDocIds
        },
        country: selectedCountry,
        application: process.env.REACT_APP_NAME
      });
      if (isDocDelete) {
        dispatch(setMessage({ msgDetails: 'Document Deleted successfuly', severity: 'success' }));
      } else {
        dispatch(setMessage({ msgDetails: duDocumentUploadSuccessMsg, severity: 'success' }));
      }
    } catch (error: any) {
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      } else if (isDocDelete) {
        dispatch(setMessage({ msgDetails: 'Error in Document Delete', severity: 'success' }));
      } else {
        dispatch(setMessage({ msgDetails: duFileUploadErrorMsg, severity: 'error' }));
      }
    }
    setProgressDocUpload(false);
    setUploadDilogOpen(false);
    getAllDrugEventsData(pageNumber * pageSize, pageSize);
    setID('');
  };
  const columns = [
    {
      field: 'da_log_kit_date_time',
      headerName: 'Transfer Date',
      minWidth: 160,
      flex: 1,
      type: 'date',
      valueGetter: formatDate
    },
    {
      field: 'da_log_kit_status',
      headerName: 'Status',
      minWidth: 160,
      flex: 1,
      type: 'singleSelect',
      valueOptions: statusData?.map((item: any) => item?.code_list_value)
    },
    {
      field: 'da_log_kit_quantity',
      headerName: 'Transfer Quantity',
      minWidth: 110,
      flex: 1,
      type: 'number'
    },
    {
      field: 'da_log_kit_from',
      headerName: 'From',
      minWidth: 110,
      flex: 1
    },
    {
      field: 'da_log_kit_to',
      headerName: 'To',
      minWidth: 110,
      flex: 1
    },
    {
      field: 'da_log_kit_reason',
      headerName: 'Reason',
      minWidth: 110,
      flex: 1
    },
    {
      field: 'da_log_kit_balance_forward',
      headerName: 'Balance Forward',
      minWidth: 70,
      flex: 1,
      type: 'number'
    },
    {
      field: 'da_log_kit_initials',
      headerName: "Recorder's initials",
      minWidth: 90,
      flex: 1
    },
    {
      field: 'action',
      headerName: 'Action',
      minWidth: 130,
      flex: 1,
      disableExport: true,
      filterable: false,
      renderCell: (params: any) => {
        return (
          <>
            <IconButton sx={{ mr: 0.5 }} onClick={() => handleFileUploadOpen(params.row)} title="Attach File">
              <AttachFileIcon color="primary" />
              <Badge
                badgeContent={params.row.docCount}
                color="primary"
                className="smallBadgeSearch"
                sx={{ mt: -2.5 }}
              />
            </IconButton>
            <IconButton onClick={() => handleComment(params.row)} title="Comment">
              <CommentIcon sx={{ color: '#2196F3' }} />
            </IconButton>
            {(archLevel == 'site' && checkPermission('update_kit_transfer_event')) ||
            (archLevel == 'sponsor' &&
              checkPermission('dar_transfer_sponsor_approval') &&
              params.row?.da_log_kit_send_to?.includes(email) &&
              params.row?.da_log_kit_status != 'Approved' &&
              params.row?.da_log_kit_status != 'Rejected') ? (
              <IconButton onClick={() => handleEdit(params.row)} title="Edit">
                <EditIcon />
              </IconButton>
            ) : (
              <></>
            )}
          </>
        );
      }
    }
  ];
  const handleCancelAddEvent = () => {
    setTransferPopupEvent(false);
    setOnEdit(false);
    setUpdateEditData({});
  };

  const getAllDrugEventsData = async (from: number, size: number) => {
    setProgress(true);
    const result: any = await getDrugEventRecords({
      site_id: selectedSite,
      study_id: studyId,
      kit_id: kitData.da_log_kit_id,
      data: filterObject,
      country: selectedCountry,
      application: currentAppName,
      da_log_kit_event: 'Transferred',
      from,
      size
    });
    if (result?.isSuccess) {
      let updated = [];
      if (result.data && result.data.selected_data.length > 0) {
        setRowsCount(result?.data.record_count);
        updated = result?.data.selected_data.map((item: any) => {
          return {
            id: item.event_data.id,
            documents_data: item.file_ids,
            docCount: item.file_ids.length,
            ...item.event_data
          };
        });
      } else {
        setRowsCount(0);
      }
      setRows(updated);
      setPendingTransfers(
        result.data.selected_data.filter(
          (item: any) =>
            item?.event_data?.da_log_kit_send_to?.includes(email) &&
            item?.event_data?.da_log_kit_status == 'Pending Approval'
        ).length
      );
    } else if (result?.isError) {
      setRows([]);
      setRowsCount(0);
      if (result?.error?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (result?.error?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
    setProgress(false);
  };

  const [sendToAdded, setSendToAdded] = useState(false);
  const handleAddTransferred = async (data: any) => {
    if (data?.da_log_kit_send_to.length > 0) {
      setSendToAdded(true);
    }
    await createDrugEventRecords({
      site_id: selectedSite,
      study_id: studyId,
      kit_id: kitData.da_log_kit_id,
      data: {
        ...data,
        da_log_kit_event: 'Transferred',
        da_log_kit_status: data?.da_log_kit_send_to?.length > 0 ? 'Pending Approval' : null,
        da_log_kit_send_to: data?.da_log_kit_send_to?.length > 0 ? data.da_log_kit_send_to.join(',') : null,
        created_by: user
      },
      country: selectedCountry,
      application: process.env.REACT_APP_NAME
    });
    setTransferPopupEvent(false);
    getAllDrugEventsData(0, pageSize);
    setSendToAdded(false);
  };
  const handleEditTransferred = async (data: any) => {
    if (
      updateEditData.da_log_kit_date_time === data.da_log_kit_date_time.slice(0, -1) &&
      updateEditData.da_log_kit_quantity === data.da_log_kit_quantity &&
      updateEditData.da_log_kit_quantity_unit === data.da_log_kit_quantity_unit &&
      updateEditData.da_log_kit_from === data.da_log_kit_from &&
      updateEditData.da_log_kit_to === data.da_log_kit_to &&
      updateEditData.da_log_kit_reason === data.da_log_kit_reason &&
      updateEditData.da_log_kit_balance_forward === data.da_log_kit_balance_forward &&
      updateEditData.da_log_kit_status === data.da_log_kit_status &&
      updateEditData?.da_log_kit_send_to.toString() == data?.da_log_kit_send_to.toString() &&
      updateEditData?.da_log_kit_message_to_sponsor == data?.da_log_kit_message_to_sponsor
    ) {
      dispatch(setMessage({ msgDetails: 'No change in data and hence cannot save the information', severity: 'info' }));
      setUpdateEditData({});
      setTransferPopupEvent(false);
      setOnEdit(false);
    } else {
      try {
        await updateDrugEventRecords({
          id,
          data: {
            ...data,
            da_log_kit_send_to: data.da_log_kit_send_to ? data.da_log_kit_send_to.join(',') : null,
            updated_by: user
          },
          country: selectedCountry,
          application: process.env.REACT_APP_NAME
        });
        let msgDetails = 'Data updated successfully';
        if (data?.da_log_kit_status == 'Approved') {
          msgDetails = 'Approved Successfully';
        } else if (data?.da_log_kit_status == 'Rejected') {
          msgDetails = 'Rejected Successfully';
        } else if (
          updateEditData?.da_log_kit_send_to?.toString() != data?.da_log_kit_send_to?.toString() &&
          data?.da_log_kit_send_to?.length > 0
        ) {
          msgDetails = 'Successfully submitted request for sponsor approval';
        }
        dispatch(setMessage({ msgDetails, severity: 'success' }));
      } catch (error: any) {
        if (error && error?.response?.status === 403) {
          dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
        } else if (error && error.response?.status === 401) {
          dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
        } else {
          dispatch(setMessage({ msgDetails: 'Error while adding Data', severity: 'error' }));
        }
      }
      setUpdateEditData({});
      setTransferPopupEvent(false);
      getAllDrugEventsData(pageNumber * pageSize, pageSize);
      setOnEdit(false);
    }
  };
  const handleSubmit = () => {
    formRef.current.submit(onFormSubmit);
  };
  const onFormSubmit = (data: any) => {
    if (data.errors) {
      return;
    }
    if (data.success) {
      if (onEdit) {
        handleEditTransferred({
          ...data.records,
          da_log_kit_status: data?.records.da_log_kit_send_to?.length > 0 ? 'Pending Approval' : null,
          da_log_kit_date_time: moment(data.records.da_log_kit_date_time).utcOffset(0, true).format()
        });
      } else {
        handleAddTransferred({
          ...data.records,
          da_log_kit_date_time: moment(data.records.da_log_kit_date_time).utcOffset(0, true).format()
        });
      }
    }
  };
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `Drug Accountability Record-Transfer ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  const dataTableProps = {
    filterMode: 'server'
  };
  const filterValues = (data: any) => {
    setFilterObject(data);
  };

  const [getPharmacyList, { data: pharmacyListData }] = useGetPharmacyListMutation();
  const { siteStudyPersonnelQueryData, getSiteStudyPersonnelQueryData } = useSiteContactInfo();

  useEffect(() => {
    getPharmacyList({
      study_id: studyId,
      site_id: selectedSite,
      application: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
    });
    getSiteStudyPersonnelQueryData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
    });
  }, [selectedSite]);

  useEffect(() => {
    setPharmacyList(
      pharmacyListData?.map((item: any) => {
        return { key: item.pharmacy_name, displayName: item.pharmacy_name };
      })
    );
  }, [pharmacyListData]);

  useEffect(() => {
    const emails = siteStudyPersonnelQueryData?.personnel
      ?.filter((item: any) => item.site_per_frole == 'CRA')
      .map((item: any) => item.site_per_email);
    const emailsCRA: any = [...new Set(emails)];
    setCraEmails(
      emailsCRA?.map((item: any) => {
        return { key: item, displayName: item };
      })
    );
  }, [siteStudyPersonnelQueryData]);

  useEffect(() => {
    const from_pharmacy = groups[0].fields.find((item: any) => item.name === 'da_log_kit_from');
    const to_pharmacy = groups[0].fields.find((item: any) => item.name === 'da_log_kit_to');
    if (from_pharmacy) {
      from_pharmacy.values = pharmacyList;
    }
    if (to_pharmacy) {
      to_pharmacy.values = pharmacyList;
    }
  }, [pharmacyList]);

  useEffect(() => {
    const sendTo = groups[1].fields.find((item: any) => item.name === 'da_log_kit_send_to');
    if (sendTo) {
      sendTo.values = craEmails;
    }
  }, [craEmails]);

  const handleApprove = () => {
    handleEditTransferred({ ...updateEditData, da_log_kit_status: 'Approved' });
    setTransferPopupEvent(false);
    setOnEdit(false);
    getAllDrugEventsData(0, pageSize);
  };

  const handleReject = () => {
    handleEditTransferred({ ...updateEditData, da_log_kit_status: 'Rejected' });
    setTransferPopupEvent(false);
    setOnEdit(false);
    getAllDrugEventsData(0, pageSize);
  };

  const customButtons = {
    REJECT: { callBack: handleReject, color: '#ED6C02' },
    APPROVE: { callBack: handleApprove }
  };

  const disabledGroups = groups.map((ele: any) => {
    return {
      ...ele,
      fields: ele.fields.map((item: any) => {
        return {
          ...item,
          disabled: true
        };
      })
    };
  });

  const disableSendTo = groups.map((ele: any) => {
    if (ele.groupName == 'DAR_Transfer_AddKitPopUp_SponsorApproval') {
      return {
        ...ele,
        fields: ele.fields.map((item: any) => {
          return {
            ...item,
            disabled: true
          };
        })
      };
    } else {
      return ele;
    }
  });
  useEffect(() => {
    if (createDrugEventRecordsSuccess && sendToAdded) {
      dispatch(setMessage({ msgDetails: 'Successfully submitted request for sponsor approval', severity: 'success' }));
    }
  }, [createDrugEventRecordsSuccess]);

  return (
    <div>
      <DataTable
        height="66vh"
        paging
        pagination
        hasDefinedColumns
        hasDefinedDataGridToolbarExport
        definedGridToolbarExport={definedCustomDatGridExport}
        pageSize={pageSize}
        setPageSize={setPageSize}
        columns={columns}
        rows={rows}
        exportCSVName={`Drug Accountability Record-Transfer`}
        datePreference={userPreferedDateFormat}
        loading={progress}
        rowsCount={rowsCount}
        page={pageNumber}
        setPageNumber={setPageNumber}
        paginationMode="server"
        dataTableProps={dataTableProps}
        filterValues={(data: any) => filterValues(data)}
      />

      <AppModal
        open={transferPopupEvent}
        title={formGroup.header}
        handleSubmit={handleSubmit}
        handleClose={handleCancelAddEvent}
        customButtons={archLevel == 'sponsor' && customButtons}
      >
        <FormLayoutBuilder
          isDisableRule
          initialValues={onEdit ? updateEditData : defaultValues}
          rules={rules}
          ref={formRef}
          groups={
            archLevel == 'sponsor'
              ? disabledGroups
              : updateEditData?.da_log_kit_send_to?.length > 0
              ? disableSendTo
              : groups
          }
          columnSpacing={2}
          onChange={onchange}
        />
      </AppModal>
      <Notes
        commentDilogOpen={commentDilogOpen}
        setCommentDilogOpen={setCommentDilogOpen}
        notesData={notesData}
        handleSendNote={handleSendNote}
        notetext={notetext}
        setNoteText={setNoteText}
        permission={checkPermission('update_kit_transfer_event')}
      />
      <DARDocUpload
        documentMetaData={documentMetaData}
        uploadDilogOpen={uploadDilogOpen}
        setUploadDilogOpen={setUploadDilogOpen}
        uploadedFiles={uploadedFiles}
        updateDocs={updateDocs}
        progress={progressDocUpload}
        permission={checkPermission('update_kit_transfer_event')}
      />
    </div>
  );
};

export default Transfer;
